import { ApiRequest, patchItem, postItem } from "utils/ApiUtils";
import { resolveDomainRef, buildReference } from "utils/SchemaUtils";
import buildQuery from 'odata-query';
import { SysUser, AADUser } from 'classes';
import ODataUtil from "./ODataUtil";

const sysUserEndpoint = "/SysUser";

const AADUserDependencies = [
  {
    "name": "LuSystemRole",
    "$ref": "/api/Domain?domainName=LuSystemRole&includeReserved=false",
    "constant": "domainId",
    "title": "description",
    "options": []
  },
  {
    "name": "UserGroup",
    "$ref": "/api/UserGroup",
    "constant": "userGroupId",
    "title": "description",
    "options": []
  }
]

async function getSysUsers(page, per_page, orderByInfo, orderByDirection, search, filters) {


  const { skip, count, top, expand, orderBy, mappedFilter } = ODataUtil.UtilityBuilderNestedv3(
    per_page, page, SysUser.expand, orderByInfo, orderByDirection, filters)
  const filter = {};
  const allFilters = mappedFilter.reduce((a, b) => ({ ...a, ...b }), filter);
  const params = buildQuery({ count, top, skip, orderBy, expand, filter: allFilters });
  const data2 = await ApiRequest(sysUserEndpoint, params);

  const modifiedData = data2.value.map(r => {
    const sysUser = new SysUser(r);
    console.log(sysUser)
    sysUser.DeviceType_SyncLogging = r.SyncLogging && r.SyncLogging[0] ? r.SyncLogging[0].DeviceType : "";
    sysUser.AppVersion_SyncLogging = r.SyncLogging && r.SyncLogging[0] ? r.SyncLogging[0].AppVersion : "";
    sysUser.Timestamp_SyncLogging = r.SyncLogging && r.SyncLogging[0] ? r.SyncLogging[0].Timestamp : "";
    return sysUser;
  }
  );

  console.log(modifiedData)

  const model = SysUser;
  const endpoint = sysUserEndpoint;
  const data = await ODataUtil.gridQuery(page, per_page, orderByInfo, orderByDirection, search, filters, { model, endpoint });
  //return data;
  return {
    data: modifiedData,
    count: data2['@odata.count']
  };
};


async function updateSysUser(values) {
  const endpoint = "/SysUser/Update";
  const sysUserId = values.SystemUserId;
  const data = values;
  const urlParams = `?sysuserid=${sysUserId}`
  const result = await patchItem(endpoint, urlParams, data);
  return result;
}

async function searchUsers(searchTerm) {
  const endpoint = sysUserEndpoint;
  const params = buildQuery({ top: 10, filter: { Name: { contains: searchTerm } } });
  const data = await ApiRequest(endpoint, params);
  return data.value.map(r => new SysUser(r));
}

async function searchAADUsers(searchTerm) {
  const endpoint = "/SysUser/Users";
  const params = `?srchptrn=${searchTerm}`;
  if (searchTerm.length >= 3) {
    const data = await ApiRequest(endpoint, params);

    return data.users.map(r => new AADUser({ Name: r.displayName, Title: r.jobTitle, Id: r.id }));
  } else {
    return [];
  }
};

async function addAADUser({ id, title, assigntoprojects, isqcreviewer, sysrole, usergrp, inspid }) {
  const endpoint = '/SysUser/Add'
  const paramsObj = { title, assigntoprojects, isqcreviewer, sysrole, usergrp, inspid };
  const params = `?${new URLSearchParams(paramsObj).toString()}`;

  const body = { id };

  const req = await postItem(endpoint, params, body, false, false);
  return req;
}

const getAADUserFormDependencies = async (dependencies) => {

  for (const [index, { name, $ref, constant, title }] of dependencies.entries()) {
    const refs = await resolveDomainRef($ref);
    const _options = buildReference(name, refs.data, constant, title);
    dependencies[index].options = _options[name]
  };
  return dependencies;
}

export {
  searchUsers, searchAADUsers, addAADUser, getAADUserFormDependencies,
  AADUserDependencies, getSysUsers, updateSysUser
};